import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayCategoryPipe',
  standalone: true,
})
export class DisplayCategoryPipe implements PipeTransform {
  transform(val: string): string {
    if (val?.toLowerCase()?.indexOf('-ss') > -1) {
      return val?.toLowerCase()?.substring(0, val.indexOf('-ss'))?.trim();
    } else if (val?.toLowerCase()?.indexOf('- ss') > -1) {
      return val?.toLowerCase()?.substring(0, val.indexOf('- ss'))?.trim();
    } else {
      return val;
    }
  }
}
